export const localStorageItemName = {
    accessToken: "accessToken",
    appSettings: "appSettings",
    appVersion: "appVersion",
    columnView: "columnView",
    dashboardFilters: "dashboardFilters",
    documentsPrefilter: "documentsPrefilter",
    domainList: "DomaineList",
    idToken: "idToken",
    isAutoLogin: "isAutoLogin",
    isRoleSelected: "isRoleSelected",
    language: "language",
    listDocumentType: "listDocumentType",
    listFunction: "listFunction",
    listNatures: "listNatures",
    listType: "listType",
    mainConfig: "mainConfig",
    postalParameterConfig: "PostalParameterConfig",
    searchQuery: "searchQuery",
    selectedProduct: "selectedProduct",
    selectedRole: "selectedRole",
    tenantUser: "tenantUser",
    userEmail: "userEmail",
    userRightList: "userRightList"
}
